import React from 'react';
import { FileCheck, HandCoins, ShieldCheck, PenLine } from 'lucide-react';
import { cn } from '../../lib/utils';
const POINTS = [{
  icon: FileCheck,
  title: 'Clear scope and fee first',
  body: 'You receive the proposed scope and a confirmed fee before any work begins, so you can decide with the cost in front of you.'
}, {
  icon: HandCoins,
  title: 'No obligation to proceed',
  body: 'A quote is just a quote. There is no obligation to continue after we set out the scope and fee for your matter.'
}, {
  icon: ShieldCheck,
  title: 'No surprise costs',
  body: 'Additional costs are not added later without your agreement. If the matter changes, we talk to you first.'
}, {
  icon: PenLine,
  title: 'You approve before we start',
  body: 'Engagement is confirmed separately and in writing. Work begins once you have approved the scope and fee.'
}];
interface FeeTransparencyProps {
  variant?: 'background' | 'cream';
}
export function FeeTransparency({
  variant = 'cream'
}: FeeTransparencyProps) {
  return <section className={cn('px-5 md:px-6 py-20 md:py-28', variant === 'cream' ? 'bg-cream' : 'bg-background')} data-id="element-513">
      <div className="max-w-7xl mx-auto" data-id="element-514">
        <div className="max-w-2xl mb-12" data-id="element-515">
          <p className="font-script text-2xl text-accent mb-1" data-id="element-516">no bill shock</p>
          <h2 className="font-serif text-3xl md:text-[2.6rem] text-ink leading-tight" data-id="element-517">
            How our fees work.
          </h2>
          <p className="mt-4 text-lg text-muted-ink leading-relaxed" data-id="element-518">
            Fees depend on the property and the transaction, so we set out a
            confirmed fixed scope and fee up front. You know what you are paying
            before anything starts.
          </p>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5" data-id="element-519">
          {POINTS.map(point => {
          const Icon = point.icon;
          return <div key={point.title} className="h-full flex flex-col rounded-2xl bg-surface border border-border p-6 shadow-card" data-id="element-520">
                <span className="inline-flex items-center justify-center w-12 h-12 rounded-2xl bg-accent-soft text-accent mb-4" data-id="element-521">
                  <Icon className="w-6 h-6" data-id="element-522" />
                </span>
                <h3 className="font-serif text-lg text-ink" data-id="element-523">{point.title}</h3>
                <p className="mt-2 text-sm text-muted-ink leading-relaxed" data-id="element-524">
                  {point.body}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}